import { SignedIn, SignedOut, useClerk } from "@clerk/tanstack-react-start";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/app/onboarding")({
  component: OnboardingFallback,
});

function OnboardingFallback() {
  const navigate = useNavigate();
  const { signOut } = useClerk();

  return (
    <>
      <SignedIn>
        <div className="flex min-h-screen w-full items-center justify-center bg-background px-4">
          <div className="flex w-full max-w-lg flex-col items-center gap-6 text-center">
            <div className="space-y-2">
              <h1 className="font-semibold text-2xl tracking-tight">
                Almost there
              </h1>
              <p className="text-muted-foreground">
                Your account is active, but it has not been assigned to an
                organization yet. Ask an administrator to add you or accept the
                latest invitation once it arrives.
              </p>
            </div>
            <div className="flex w-full flex-col gap-3 sm:flex-row sm:justify-center">
              <Button onClick={() => navigate({ to: "/" })} type="button">
                Go back home
              </Button>
              <Button
                onClick={() => signOut({ redirectUrl: "/" })}
                type="button"
                variant="outline"
              >
                Sign out
              </Button>
            </div>
          </div>
        </div>
      </SignedIn>
      <SignedOut>
        <div className="flex min-h-screen items-center justify-center px-4">
          <p className="text-muted-foreground">
            You need to sign in to continue.
          </p>
        </div>
      </SignedOut>
    </>
  );
}
